import { css } from 'lit';

export const style = css`
  .sign-in-card {
    align-items: center;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    display: flex;
    margin: 0 auto;
    max-width: 24em;
    padding: 1.25em 1em;
  }

  .sign-in-card__content {
    margin-left: 1.5em;
  }

  .sign-in-card__header {
    font-size: 1em;
    font-weight: 700;
  }

  .sign-in-card__body {
    font-size: 0.875em;
  }
`;
